import { ImageWMS } from 'ol/source';
import {Group, Image as ImageLayer} from 'ol/layer';

const urlEstadistica=import.meta.env.VITE_GEOSERVER_URL;

//
const ministerioEducacion=[
    {title:'Establecimientos Privados',layer:'ministerio_educacion_establecimientos_privados'},
    {title:'Establecimientos Públicos',layer:'ministerio_educacion_establecimientos_estatales'}
]

const imageLayersMinisterioEducacion=ministerioEducacion.map(({title,layer})=>new ImageLayer({
    title,
    visible:false,
    source: new ImageWMS({
        url: `${urlEstadistica}/otros/wms`,
        params: { 'LAYERS': layer, grupo:'otros' },
        serverType: 'geoserver',
        crossOrigin:'Anonymous'
    })
}))
//
const ministerioSalud=[
    {title:'Efectores de Salud',layer:'ministerio_salud_efectores_de_salud'},
]

const imageLayersMinisterioSalud=ministerioSalud.map(({title,layer})=>new ImageLayer({
    title,
    visible:false,
    source: new ImageWMS({
        url: `${urlEstadistica}/otros/wms`,
        params: { 'LAYERS': layer },
        serverType: 'geoserver',
        crossOrigin:'Anonymous'
    })
}))
//
const ministerioDesarrolloSocial=[
    {title:'CEPLAS - SMT',layer:'ministerio_desarollo_social_ceplas'},
    {title:'Dispositivos Comunitarios',layer:'ministerio_desarollo_social_dispositivos_comunitarios'},
]

const imageLayersMinisterioDesarrolloSocial=ministerioDesarrolloSocial.map(({title,layer})=>new ImageLayer({
    title,
    visible:false,
    source: new ImageWMS({
        url: `${urlEstadistica}/otros/wms`,
        params: { 'LAYERS': layer },
        serverType: 'geoserver',
        crossOrigin:'Anonymous'
    })
}))

//
const gobiernoNacional=[
    {title:'Barrios del Registro Nac. de Barrios Populares (ReNaBap)',layer:'gobierno_nacional_barrios_renabap'},
]

const imageLayersGobiernoNacional=gobiernoNacional.map(({title,layer})=>new ImageLayer({
    title,
    visible:false,
    source: new ImageWMS({
        url: `${urlEstadistica}/otros/wms`,
        params: { 'LAYERS': layer },
        serverType: 'geoserver',
        crossOrigin:'Anonymous'
    })
}))


// fuentes externas/ otros
export const fuentesExternas=new Group({
    title: 'Fuentes externas',
    fold: 'close',
    layers:[
        new Group({
            title: 'Ministerio de Educación',
            fold: 'close',
            layers: imageLayersMinisterioEducacion
        }),
        new Group({
            title: 'Ministerio de Salud',
            fold: 'close',
            layers: imageLayersMinisterioSalud
        }),
        new Group({
            title: 'Ministerio de Desarrollo Social',
            fold: 'close',
            layers: imageLayersMinisterioDesarrolloSocial
        }),
        new Group({
            title: 'Dirección General de Catastro',
            fold: 'close',
            layers:[
                new ImageLayer({
                    title: 'Circuitos Electorales',
                    visible:false,
                    source: new ImageWMS({
                        url: `${urlEstadistica}/otros/wms`,
                        params: { 'LAYERS': 'circuitos_electorales' },
                        serverType: 'geoserver',
                        crossOrigin:'Anonymous'
                    })
                })
            ]
        }),
        new Group({
            title: 'Gobierno Nacional',
            fold: 'close',
            layers: imageLayersGobiernoNacional
        }),
        
    ]
})

